import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { DCInput } from '../dynamic_components/dynamic.service';
import { IPTVVideoService } from '../iptv-video/iptv-video.service';
import { Channel } from '../IPTV_Editor/iptv_editor.component';
import { Ajax } from 'src/app/services/ajax.service';
import { EPG_Bundle } from './epg.interfaces';
@Component({
    selector: 'epg-window',
    templateUrl: 'epg_window.component.html',
    styleUrls: ['epg_window.component.css']
})

export class EpgWindowComponent implements OnInit, OnDestroy, DCInput {
    title = "Программа передач";
    destroyEmitter = new EventEmitter<null>();
    /**
     * Массив программ передач
     */
    EPG_Bundle:EPG_Bundle = {epg:[], played_programm: null};
    channel:Channel = null;
    /**
     * Слушатель загрузки предыдущей программы передач
     */
    $load_prev = new EventEmitter<null>();
    constructor(private _player:IPTVVideoService, private _ajax:Ajax) {
     }
    ngOnInit(){

     }
    ngOnDestroy(){
        this.destroyEmitter.complete();
        this.$load_prev.complete();
    }
    /**
     * Загрузка истории предыдущего EPG
     */
    load_prev_epg(){
        this.$load_prev.emit(null);
    }
    close(){
        this.destroyEmitter.emit(null);
    }
    /**
     * Включение канала из архива
     * @param i Индекс объекта в epg
     * @param e InputEvent Событие для ползунка. Если нет, тогда программа запускается с начала по клику на временной метке.
     */
    archive_play(i:number, e?:Event){
        
        const start = Math.floor(this.EPG_Bundle.epg[i].start),
            // Окончание программы берем из начала следующей программы, если нет, тогда выставляем в 1 час к текущему времени
              stop = this.EPG_Bundle.epg[i+1] ? Math.floor(this.EPG_Bundle.epg[i+1].start): (Date.now()/1000) + 60*60,
              target = e ? <HTMLInputElement>e.target : null;
        let delta = 0;
        if(target){
            delta = stop - start;
            delta = Math.floor((parseInt(target.value)/100) * delta);
        }
        const playTime = start + delta;
        if(target && playTime >= (new Date()).getTime()/1000){
            target.value = this.EPG_Bundle.epg[i].progress.toString();
            return false;
        } else {
            const lutc = Math.floor((new Date()).getTime()/1000),
                  url = this.channel.url.indexOf("?") > 0 ? this.channel.url+`&utc=${playTime}&lutc=${lutc}` : 
                                                            this.channel.url+`?utc=${playTime}&lutc=${lutc}`,
                  epg_current = this.EPG_Bundle.epg[i];
            epg_current.stop = stop;
            if(target){
                epg_current.progress = parseFloat(target.value);
            } else {
                epg_current.progress = 0;
            }

            this.EPG_Bundle.played_programm = this.EPG_Bundle.epg[i];
            this._player.channel = this.channel;
            this._player.play(url);
            this._player.epgCurrent = epg_current;
            this.close();
        }
    }
    /**
     * Движущийся указатель мыши для выбора времени запуска архива.
     * @param e 
     */
    archive_pointer(i:number, e: MouseEvent & TouchEvent) {
        const rect = (<HTMLInputElement>e.target).getBoundingClientRect(),
            epg = this.EPG_Bundle.epg[i],
            start = Math.floor(epg.start),
            stop = this.EPG_Bundle.epg[i+1] ? Math.floor(this.EPG_Bundle.epg[i+1].start) : (Date.now()/1000) + 60*60,
            delta = stop - start,
            clientX = e.touches ? e.touches[0].clientX : e.clientX,
            pointer = (clientX - rect.left)/rect.width; 
            if(pointer < 0 || pointer > 1) return false;
            epg.pointTime = Math.floor(pointer * delta + start);
    }
    /**
     * Создаем задержку появления поля range, так как в мобильной версии при тапе сразу изменялось поле range
     * @param e MouseEvent
     */
    li_mouseenter(e:MouseEvent){
        if((<HTMLElement>e.target).className.indexOf("played") < 0){
            const element = <HTMLInputElement>(<HTMLElement>e.target).getElementsByClassName("archive_range")[0];
            element.disabled = true;
            setTimeout(()=>{
                element.disabled = false;
            },100);
        }
    }
    
}

